export default __webpack_public_path__ + "static/media/ivInfusionIcon.bb89eeb1.svg";